import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserHazardList.css";
import Sidebar from "../Components/Sidebar";

const UserHazardList = () => {
  const [hazards, setHazards] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");

    fetch(`${process.env.REACT_APP_API_URL}/user_hazards`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          setHazards(res.data);
        }
      });
  }, []);

  const renderStars = (score) => {
    const maxStars = 5;
    const filledStars = Math.round(score); // Assuming score is from 0 to 5
    const emptyStars = maxStars - filledStars;

    return (
      <div className="usr-hazard-stars">
        {"★".repeat(filledStars)}
        <span className="usr-hazard-empty-stars">{"☆".repeat(emptyStars)}</span>
      </div>
    );
  };

  return (
    <div className="overview">
      <Sidebar />
      <div className="usr-hazard-list">
        <h2>Your Hazard Attempts</h2>
        <div className="usr-hazard-grid">
          {hazards.map((hazard) => (
            <div
              key={hazard.user_hazard_id}
              className="usr-hazard-card"
              onClick={() =>
                navigate(`/review-hazards/${hazard.user_hazard_id}`)
              }
            >
              <img
                src={hazard.thumbnail}
                alt={`Hazard ${hazard.user_hazard_id}`}
                className="usr-hazard-thumb"
              />
              <div className="usr-hazard-score">
                {renderStars(hazard.score)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserHazardList;
